// import Repository from '@/libs/axios'
import OperationRepository from '@/libs/customAxios/operationAxios'

const assignedWaybillSeriesResource = '/merchant/waybill-series-assignment'
const waybillSettingResource = '/merchant/waybill-series'

export default {
  fetchAssignedWaybillSeries() {
    return OperationRepository.get(`${assignedWaybillSeriesResource}/get-assigned-waybills`)
  },
  getLongestWaybillNumberLength() {
    return OperationRepository.get(`${waybillSettingResource}/get-longest-waybill-number-length`)
  },
}
